import { Theme } from '@mui/material/styles'
import { useMemo, type CSSProperties } from 'react'

const classes = {
  card: {
    background: (theme: Theme) => theme.palette.common.white,
    border: '1px solid #E2E2E2',
    borderRadius: '4px',
    boxShadow: '0px 2px 6px rgba(194, 194, 194, 0.5)',
    color: (theme: Theme) => theme.palette.text.primary,
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
    padding: (theme: Theme) => theme.spacing(0.8),
    maxWidth: 'var(--maxWidth)',
    '& p': {
      lineHeight: 'var(--lineHeight)',
    },
    width: 'var(--width)',
  },

  loadingBox: {
    textAlign: 'center',
  },
}

export function useStyles(maxWidth: string, width: string) {
  const styles = useMemo(() => {
    return {
      card: {
        '--maxWidth': `${maxWidth}`,
        '--width': `${width}`,
      } as CSSProperties,
    }
  }, [maxWidth, width])

  return [classes, styles] as const
}
